/* eslint-disable */

import axios from "axios";
import constant from "./constant";

const vendorloginUrl = "vendor/login"
const vendordataUrl = "vendor/getvendordata"
const getgigsdataUrl = "gigs/getgigsdata"
const addgigsUrl = "gigs/addgigsdata"
const getvendorcatdataUrl = "gigs/getvendorcatdata"
const getvendorsubcatdataUrl = "gigs/getvendorsubcatdata"

function getauthtoken(){
    let token = localStorage.getItem('AUTH_TOKEN');
    let Authtoken = '';
    if(token !=null && token !='' && token !=undefined){
        Authtoken = token;
    }
    const config = {
      headers: { 'XAuthorization': `Bearer ${Authtoken}` }
    };
    return config;

  }

const client = axios.create({
    baseURL: constant.API_URL,
  });

  export class ApiService {


vendorloginPostRequest(request) {
  return client.post(vendorloginUrl, request)
}

vendordataPostRequest(request) {
  return client.post(vendordataUrl, request, getauthtoken())
}

gigsdataRequest() {
  return client.get(getgigsdataUrl, getauthtoken())
}

addgigsdataPostRequest(request) {
  return client.post(addgigsUrl,request ,  getauthtoken())
}

gigsvendorcatdataRequest() {
  return client.get(getvendorcatdataUrl, getauthtoken())
}
getvendorsubcatdata(request) {
  return client.post(getvendorsubcatdataUrl, request, getauthtoken())
}
}
